import LeaveStatCard from "./LeaveStatCard.jsx";

const EmployeeLeaveHeader = ({
  employeeData,
  statusBadge,
  totalLeaves,
  totalLeavesTaken,
  employeeLeaveCounts,
  purpleIcon,
  redIcon,
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <img
          src={employeeData.user?.profile_picture}
          alt="Employee"
          className="w-14 h-14 rounded-full object-cover ring-2 ring-offset-2 ring-[var(--primary-color)]/30"
        />

        <div>
          <h4 className="text-base font-semibold m-0 text-medium-dark-gray">
            {employeeData.user?.employee_full_name}
          </h4>

          <p className="text-sm font-normal m-0 text-muted">
            {employeeData.user?.roles[0]?.role_name}
          </p>

          <span
            className={`mt-1.5 inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${statusBadge.className}`}
          >
            <span className="h-1.5 w-1.5 rounded-full bg-current" />
            {statusBadge.label}
          </span>
        </div>
      </div>

      <div className="flex gap-3">
        <LeaveStatCard
          title="Total Available"
          value={totalLeaves}
          icon={purpleIcon}
          items={employeeLeaveCounts}
          field="count"
          iconBgColor="bg-[#f4f3ff]"
        />

        <LeaveStatCard
          title="Leaves Taken"
          value={totalLeavesTaken}
          icon={redIcon}
          items={employeeLeaveCounts}
          field="leave_days_taken"
          iconBgColor="bg-[#fff3f3]"
        />
      </div>
    </div>
  );
};

export default EmployeeLeaveHeader;